import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { TicketStatus } from './ticket-status';
import { TicketPriority } from './ticket-prioritty';

@JsonObject('model.project.Project')
export class Ticket extends AbstractModel {

	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(String, 'type')
	type?: string;

	@JsonProperty(TicketPriority, 'priority')
	priority?: TicketPriority;

	@JsonProperty(Number, 'priorityId')
	priorityId?: number;

	@JsonProperty(String, 'summary')
	summary?: string;

	@JsonProperty(DateConverter, 'created-at')
	createdAt?: Date;

	@JsonProperty(DateConverter, 'updated-at')
	updatedAt?: Date;

	@JsonProperty(String, 'description')
	description?: string;

	@JsonProperty(String, 'location')
	location?: string;

	@JsonProperty(TicketStatus, 'status')
	status?: TicketStatus;

	@JsonProperty(Ticket, 'testTicket')
	testTicket?: Ticket;
}
